var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.628 11.042C2.956 11.042 2.354 10.874 1.822 10.538C1.318 10.202 0.926 9.74 0.646 9.152C0.366 8.536 0.226 7.822 0.226 7.01C0.226 6.31 0.338 5.652 0.562 5.036C0.786 4.392 1.108 3.804 1.528 3.272C1.976 2.712 2.508 2.208 3.124 1.76C3.768 1.284 4.496 0.877998 5.308 0.541999L6.442 2.054C5.518 2.53 4.776 3.062 4.216 3.65C3.656 4.238 3.376 4.798 3.376 5.33C3.376 5.694 3.474 6.016 3.67 6.296C3.866 6.576 4.146 6.87 4.51 7.178C4.958 7.514 5.266 7.836 5.434 8.144C5.63 8.452 5.728 8.774 5.728 9.11C5.728 9.698 5.532 10.174 5.14 10.538C4.776 10.874 4.272 11.042 3.628 11.042ZM11.44 11.042C10.768 11.042 10.166 10.874 9.634 10.538C9.13 10.202 8.738 9.74 8.458 9.152C8.178 8.536 8.038 7.822 8.038 7.01C8.038 6.31 8.15 5.652 8.374 5.036C8.598 4.392 8.92 3.804 9.34 3.272C9.788 2.712 10.32 2.208 10.936 1.76C11.58 1.284 12.308 0.877998 13.12 0.541999L14.254 2.054C13.33 2.53 12.588 3.062 12.028 3.65C11.468 4.238 11.188 4.798 11.188 5.33C11.188 5.694 11.286 6.016 11.482 6.296C11.678 6.576 11.958 6.87 12.322 7.178C12.77 7.514 13.078 7.836 13.246 8.144C13.442 8.452 13.54 8.774 13.54 9.11C13.54 9.698 13.344 10.174 12.952 10.538C12.588 10.874 12.084 11.042 11.44 11.042Z",
    fill: "#F45600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.eeccc6ac62ea90a43af05f26206f73e8.svg";
export { ForwardRef as ReactComponent };